import React from "react";
import { Table, Button } from "semantic-ui-react";

export const runNewSearch = (props) => {
  if (props.actID !== "" && props.actType.indexOf("report") === -1) {
    return (
      <Table.Row key={"run_new_seaarch"}>
        <Table.Cell colSpan="3">
          <Table className="table-no-border-and-padding">
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  You are viewing results from a search you ran on{" "}
                  {props.actDate}
                  <br />
                  <span className={"text-bold red-text"}>
                    *Running a new search will incur a charge if applicable
                  </span>
                </Table.Cell>
                <Table.Cell>
                  <Button
                    className={
                      props.acctTheme === 0
                        ? "float-right-nomobile classic-submit"
                        : "float-right-nomobile"
                    }
                    onClick={(e) => props.showResults(e, props.data, "no")}
                  >
                    Run New Search
                  </Button>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
    );
  }
  return null;
};

export default runNewSearch;



// WEBPACK FOOTER //
// ./src/components/searchresults/RunNewSearch.js